export const CALL_TYPES = {
  WEB_CALL: 'web-call',
  OUTBOUND_PHONE_CALL: 'outbound-phone-call',
} as const;

export const SELECT_CALL_TYPES = {
  ...CALL_TYPES,
  WS: 'ws',
} as const;

export const INTERNAL_CALL_TYPES = {
  WEB_CALL: 'webCall',
  OUTBOUND_CALL: 'outboundCall',
} as const;

export const TIMEOUTS = {
  DISCONNECT_DELAY: 1000,
} as const;

export const ROOM_STATES = {
  CONNECTED: 'connected',
} as const;

export const DEFAULT_LIVEKIT_HOST = 'http://localhost:7880';
